import { request } from "./actions";

import type { RequestCallbacks } from "EntitiesApi/Actions";

export const getAccountSettingDetails = (meta: RequestCallbacks = {}) =>
  request(
    {
      url: `/api/v2/accounts/settings`,
      method: "get",
    },

    meta,
  );

export const requestInformation = (meta: RequestCallbacks = {}) =>
  request(
    {
      url: `/api/v2/accounts/request_information`,
      method: "post",
    },

    meta,
  );

export const requestDeleteInformation = (meta: RequestCallbacks = {}) =>
  request(
    {
      url: `/api/v2/accounts/request_delete_information`,
      method: "post",
    },

    meta,
  );
